/**
 * 文件说明: 按员工查看
 * ----------------------------------------
 * 创建用户: 1625
 * 创建日期 2021/02/04
 */

import _ from 'lodash'
import {createProjectModel} from 'crm/utils/project-model'
import {getSummary, getList, exportData} from './service'

const model = createProjectModel({
    projectNamespace: 'messagesDetailByCustomer',
    state: {
        tableList: {}, //  客户列表
        summary: [], //
    },

    effects: {
        *exportTableListData(__, {select, call}) {
            const {tableList} = yield select((allState) => allState[model.namespace])
            const newParams = {
                id: tableList.params?.id,
                body: {
                    ...tableList.params,
                },
            }

            const res = yield call(exportData, newParams)

            return res
        },
        *getTableList(__, {select, put, call}) {
            const {tableList} = yield select((allState) => allState[model.namespace])
            const newParams = {
                offset: tableList.pagination.pageSize * (tableList.pagination.current - 1),
                limit: tableList.pagination.pageSize,
                ...tableList.params,
            }
            const res = yield call(getList, {
                ...newParams,
            })
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    if (draft.tableList) {
                        draft.tableList.dataSource = res.data
                        draft.tableList.pagination.total = _.get(res, 'pagination.rows_found', 0)
                    }
                },
            })
        },
        *summary({payload}, {put, call}) {
            const res = yield call(getSummary, {
                id: payload.id,
            })
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.summary = res.data
                },
            })
        },
    },
})
export default model
